import React, {useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import {Glyphicon} from "../GlyphIcon";
import {ActivityFeedValueDisplay} from "./ActivityFeedValueDisplay";

export const ActivityFeedValueDeltaDisplay = (props) => {
    const { Viewer, FieldKey, NewValue, NewData, FieldCustomData, OldValue, OldData } = props;
    
    const [displayOld, setDisplayOld] = useState(false);
    
    const togglePreviousView = () => {
        setDisplayOld(!displayOld);
    };
    
    let rootDivClasses = "sb-activity-feed-delta-value-display";
    
    if (FieldKey) {
        rootDivClasses += ` sb-activity-feed-field-key-${FieldKey}`;
    }
    
    if (OldValue === undefined) {
        return (
            <Row className={rootDivClasses}>
                <Col xs={12} className="sb-activity-feed-delta-value-display-new-value">
                    <ActivityFeedValueDisplay
                        value={NewValue}
                        data={NewData}
                        fieldComponentName={Viewer}
                        fieldCustomData={FieldCustomData}
                    />
                </Col>
            </Row>
        );
    } else if (NewValue === undefined) {
        return (
            <Row className={rootDivClasses}>
                <Col xs={12} className="sb-activity-feed-delta-value-display-old-value">
                    <ActivityFeedValueDisplay
                        value={OldValue}
                        data={OldData}
                        fieldComponentName={Viewer}
                        fieldCustomData={FieldCustomData}
                    />
                </Col>
            </Row>
        );
    } else {
        return (
            <Row className={rootDivClasses}>
                <Col xs={12} className="sb-activity-feed-delta-value-display-new-value">
                    <ActivityFeedValueDisplay
                        value={NewValue}
                        data={NewData}
                        fieldComponentName={Viewer}
                        fieldCustomData={FieldCustomData}
                    />
                </Col>
                <Col xs={12} className="sb-activity-feed-delta-value-display-button">
                    <a className="float-right" onClick={togglePreviousView}>
                        <Glyphicon glyph="file"> {displayOld ? "Hide Previous" : "View Previous"}</Glyphicon>
                    </a>
                </Col>
                {displayOld && (
                    <Col xs={12} className="sb-activity-feed-delta-value-display-old-value">
                        <ActivityFeedValueDisplay
                            value={OldValue}
                            data={OldData}
                            fieldComponentName={Viewer}
                            fieldCustomData={FieldCustomData}
                        />
                    </Col>
                )}
            </Row>
        );
    }
};
